import { Component, OnInit, ViewChild, ViewChildren, QueryList, ElementRef, AfterViewInit } from '@angular/core';
import { Product } from '../../models/Product';
import { Observable } from 'rxjs/Observable';
import { JqueryHelperService } from '../../jquery-helper.service';
import { ProductService } from '../../shared/product.service';
import { Filter, FilterType } from '../../models/Filter';
import { FilterService } from '../../shared/filter.service';
import { AppState } from '../../models/app.state';
import { Store } from '@ngrx/store';

@Component({
  selector: 'ciu-products-and-filter',
  templateUrl: './products-and-filter.component.html',
  styleUrls: ['./products-and-filter.component.css']
})
export class ProductsAndFilterComponent implements OnInit ,AfterViewInit{
  ngAfterViewInit(): void {
    this.filters.changes.subscribe(this.jqueryHelper.test);
  }

  @ViewChildren('filters') filters: QueryList<any>;
  
  // @ViewChild(ProductfilterComponent) child: ProductfilterComponent;
  constructor(private store: Store<AppState>,
    private filterService: FilterService,
    private productService: ProductService,
    private jqueryHelper: JqueryHelperService) {

    this.loading$ = this.store.select(storeX => storeX.productsState.loading);
    this.products$ = this.productService.getProducts();
    this.activeFilters$ = this.filterService.getActiveFilteres();

    this.loadingProductsSpinnerConfig = {
      backdropBorderRadius: '14px',
      fullScreenBackdrop: true
    };
  }

  products$: Observable<Product[]>;
  loading$: Observable<boolean>;
  loadingProductsSpinnerConfig: any;
  activeFilters$: Observable<Filter[]>;

  ngOnInit() {
    this.jqueryHelper.portfolioMasonry();
    this.jqueryHelper.scrollRevealJsInit();
  }

  onRemoveFilter(filter: Filter) {
    this.filterService.removeFilter(filter);
    if (filter.type == FilterType.GEO) {
      this.jqueryHelper.refreshGeofilter();
    }
    if (filter.type == FilterType.PRICE) {
      this.jqueryHelper.refreshPricefilter();
    }
    // this.jqueryHelper.changeSlider('desktop');
    // this.jqueryHelper.changeSlider('mobile');
    if (filter.type == FilterType.SEARCH) {
      this.jqueryHelper.resetSearchInput();
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/majli/reposales365/sale365/src/app/container/products-and-filter/products-and-filter.component.ts